var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full font-regular text-base antialiased",attrs:{"id":"app"}},[_c('navbar'),_c('call-to-action',{staticClass:"md:mt-64 lg:mt-64 mt-24"}),_c('services',{staticClass:"mt-24"}),_c('contact',{staticClass:"mt-32"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }